import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RxFillAlertsDetails {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  RxFillAlertsDetailsData?: any;
  Items?: any;
  Pagination?: any;
}

const initialState: RxFillAlertsDetails = {
  isLoading: false,
  error: false,
  message: null,
  RxFillAlertsDetailsData: [],
  Items: [],
  Pagination: [],
};

const RxFillAlertsDetailsSlice = createSlice({
  name: "RxFillAlertsDetails",
  initialState,
  reducers: {
    loadingRxFillAlertsDetails: (
      state: RxFillAlertsDetails,
      action: PayloadAction<{}>
    ) => {
      state.isLoading = true;
    },
    setRxFillAlertsDetails: (
      state: any,
      action: PayloadAction<RxFillAlertsDetails>
    ) => {
      return action.payload;
    },
    clearData: (state: RxFillAlertsDetails, action: PayloadAction) => {
      state.error = false;
    },
  },
});

export const { loadingRxFillAlertsDetails, setRxFillAlertsDetails, clearData } =
  RxFillAlertsDetailsSlice.actions;
export default RxFillAlertsDetailsSlice.reducer;
